import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import {AssessorTestResult} from '../../../models/ReceivedPoll';

@Component({
  selector: 'app-assessors-votes',
  templateUrl: 'assessors-votes.component.html',
  styleUrls: ['./assessors-votes.component.less', '../../../shared/common.less'],
})

export class AssessorsVotesComponent implements OnInit {
  @Input() assessorQuorum: AssessorTestResult;
  @Input() isValidated: boolean = false;

  ngOnInit(): void {
    if (this.assessorQuorum.votedVoters == this.assessorQuorum.voters) {
      this.isValidated = true;
    }
  }
}
